import { ScopeId } from '@pubstack/common/src/scope'
import { AlertEmail, UserPreferences } from '@pubstack/common/src/user'
import { MutationToasts, useMutation } from '~/api/api-client'

export const USER_QUERY_KEYS = ['users', 'me']
const url = '/users/me'

/**
 * `preferences` is the whole bag, not a patch: Auth0 replaces everything below `user_metadata`'s root,
 * so a caller saving one preference has to send the ones it is not changing back alongside it.
 */
export const useAddUserMetadata = (toasts: MutationToasts = {}) => {
  return useMutation<{ scopeId: ScopeId; alertEmail: AlertEmail; preferences?: UserPreferences }>({
    method: 'put',
    url,
    collectionKeys: USER_QUERY_KEYS,
    ...toasts,
  })
}
